var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.586C11.9204 16.586 11.8442 16.5542 11.788 16.498L3.38799 8.098C3.27779 7.9798 3.28119 7.7956 3.39539 7.6814C3.50959 7.5672 3.69379 7.564 3.81199 7.674L12 15.862L20.188 7.674C20.3062 7.5638 20.4904 7.5672 20.6046 7.6814C20.7188 7.7956 20.722 7.9798 20.612 8.098L12.212 16.498C12.1558 16.5542 12.0796 16.586 12 16.586Z",
    fill: "#2C3439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownTwo);
export default __webpack_public_path__ + "static/media/arrow-down-two.7e2a03ea1d6e9c78c90ceaedcfe06059.svg";
export { ForwardRef as ReactComponent };